import React from 'react';
import { DraftCollection } from 'components/DraftCollection';
import Page from 'components/Page';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import useDraftList from 'hooks/useDrafts';

const DraftsPage: React.FC = () => {
  const { loading, draftSets, draftDevices } = useDraftList();
  return <Page>{loading ? <PageSpinner /> : <DraftCollection sets={draftSets} devices={draftDevices} />}</Page>;
};

export default DraftsPage;
